import { Injectable } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { WeatherCondition } from 'shared/models/timesheet.model';
import { GeoApiService } from './api/geo.api.service';
import { APIResponse } from 'shared/models/api-response';

export interface WeatherData {
  weatherCondition: WeatherCondition;
  temperature: string;
}

@Injectable({
  providedIn: 'root'
})
export class WeatherService {

  constructor(private _geoApi: GeoApiService) {}

  getWeatherByZip(zipCode: string, state: string): Observable<WeatherData | null> {
    return this._geoApi.getWeather(zipCode, state).pipe(
      map((response: APIResponse) => {
        if (!response?.success || !response?.data) return null;

        return {
          weatherCondition: response.data.weatherCondition,
          temperature: response.data.temperature
        };
      }),
      catchError(() => of(null))
    );
  }

  getWeatherByCoords(lat: number, lng: number): Observable<WeatherData | null> {
    return this._geoApi.getWeatherByCoords(lat, lng).pipe(
      map((response: APIResponse) => {
        if (!response?.success || !response?.data) return null;

        return {
          weatherCondition: response.data.weatherCondition,
          temperature: response.data.temperature
        };
      }),
      catchError(() => of(null))
    );
  }
}
